import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gallery-modal-wrapper"
}
const _hoisted_2 = { class: "gallery-modal" }
const _hoisted_3 = { class: "gallery-modal__header" }
const _hoisted_4 = { class: "gallery-modal__count" }
const _hoisted_5 = { class: "gallery-modal__nav-buttons" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "gallery-modal__title"
}
const _hoisted_9 = { class: "gallery-modal__buttons" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon--message-circle" }, null, -1 /* HOISTED */)
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = {
  key: 0,
  class: "gallery-modal__sidebar"
}
const _hoisted_14 = { class: "gallery-modal__sidebar-heading" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h2", { class: "p mb-16" }, " Comments ", -1 /* HOISTED */)
const _hoisted_16 = { class: "p" }
const _hoisted_17 = { class: "gallery-modal__comments-heading" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h4", { class: "gallery-modal__sidebar-sub-title" }, " Comments ", -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_CommentFormComponent = _resolveComponent("CommentFormComponent")
  const _component_CommentsComponent = _resolveComponent("CommentsComponent")

  return ($data.gallery_options && $data.gallery_options.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString($options.getCount()), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: _normalizeClass(["gallery-modal__nav-prev", { 'gallery-modal__nav-prev--disabled': $options.first_selected }]),
                disabled: $options.first_selected,
                onClick: _cache[0] || (_cache[0] = (...args) => ($options.viewPrev && $options.viewPrev(...args)))
              }, null, 10 /* CLASS, PROPS */, _hoisted_6),
              _createElementVNode("button", {
                class: _normalizeClass(["gallery-modal__nav-next", { 'gallery-modal__nav-next--disabled': $options.last_selected }]),
                disabled: $options.last_selected,
                onClick: _cache[1] || (_cache[1] = (...args) => ($options.viewNext && $options.viewNext(...args)))
              }, null, 10 /* CLASS, PROPS */, _hoisted_7)
            ]),
            ($options.selected_option.title)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString($options.selected_option.title), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_9, [
              ($options.selected_option.router_link)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: $options.selected_option.router_link,
                    class: "gallery-modal__button"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" View in project ")
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["to"]))
                : _createCommentVNode("v-if", true),
              ($options.selected_option.option_id)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "gallery-modal__button gallery-modal__button--invert",
                    onClick: _cache[2] || (_cache[2] = (...args) => ($options.showComments && $options.showComments(...args)))
                  }, [
                    _hoisted_10,
                    _createTextVNode(" Leave a comment ")
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("button", {
              class: "gallery-modal__close-modal",
              onClick: _cache[3] || (_cache[3] = $event => (_ctx.$emit( 'close-modal' )))
            })
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["gallery-modal__content", { 'gallery-modal__content--show-sidebar': $data.show_comments }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["gallery-modal__content-wrapper", { 'gallery-modal__content-wrapper--full-resolution': $data.show_full_resolution }])
            }, [
              ($options.selected_option.image_url)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: _normalizeClass(["gallery-modal__image", { 'gallery-modal__image--full-resolution': $data.show_full_resolution }]),
                    style: _normalizeStyle($options.full_resolution_styles),
                    src: $options.selected_option.image_url,
                    onClick: _cache[4] || (_cache[4] = (...args) => ($options.toggleFullResolution && $options.toggleFullResolution(...args)))
                  }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_11))
                : ($options.selected_option.video_url)
                  ? (_openBlock(), _createElementBlock("video", {
                      key: 1,
                      class: "gallery-modal__video",
                      src: $options.selected_option.video_url,
                      alt: $options.selected_option.title,
                      autoplay: "",
                      controls: ""
                    }, null, 8 /* PROPS */, _hoisted_12))
                  : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */),
            ($data.show_comments)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["gallery-modal__sidebar-content", { 'gallery-modal__sidebar-content--loading': $data.loading }])
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("h3", _hoisted_16, _toDisplayString($options.selected_option.title), 1 /* TEXT */)
                    ]),
                    _createVNode(_component_CommentFormComponent, {
                      "option-id": $options.selected_option.option_id,
                      onCommentPosted: $options.getComments
                    }, null, 8 /* PROPS */, ["option-id", "onCommentPosted"]),
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      ($data.comments && $data.comments.length)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: _normalizeClass(["gallery-modal__comments-sort", { 'gallery-modal__comments-sort--asc': $data.date_sort === 'asc' }]),
                            onClick: _cache[5] || (_cache[5] = (...args) => ($options.toggleDateSort && $options.toggleDateSort(...args)))
                          }, " Date ", 2 /* CLASS */))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createVNode(_component_CommentsComponent, { comments: $data.comments }, null, 8 /* PROPS */, ["comments"])
                  ], 2 /* CLASS */)
                ]))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */)
        ])
      ]))
    : _createCommentVNode("v-if", true)
}